<template>
    <div class="login_content" :style="{backgroundImage: 'url(' + bgimg + ')'}">
        <div class="login_box">
            <div class="login_clear clear">
                <div class="register_logo"><img :src="logoimg" alt="logo" /></div>
                <div class="register_content">
                    <div class="register_title"><h2>欢迎注册</h2></div>
                    <div class="register_list">
                        <Form ref="registerValidate" :model="registerValidate" :rules="registerRule">
                            <FormItem prop="phone" :show-message="false">
                                <Input v-model="registerValidate.phone" placeholder="手机号" :maxlength="11" />
                            </FormItem>
                            <FormItem prop="identifier" :show-message="false">
                                <Input v-model="registerValidate.identifier" placeholder="识别码" :maxlength="4" />
                                <div class="register_code" @click="refreshCode">
                                    <identify :identifyCode="identifyCode"></identify>
                                </div>
                            </FormItem>
                            <FormItem prop="verificationcode" :show-message="false">
                                <Input v-model="registerValidate.verificationcode" placeholder="验证码" :maxlength="4" />
                                <Button class="gain_verificationcode_btn" type="warning" :disabled="verificationCodedisabled" @click="getVerificationCode">{{identifiertxt}}</Button>
                            </FormItem>
                            <FormItem prop="invitationcode">
                                <Input v-model="registerValidate.invitationcode" placeholder="邀请码 (选填)" />
                            </FormItem>
                            <FormItem>
                                <Button class="register_submit" type="warning" long @click="handleSubmit('registerValidate')">下一步</Button>
                            </FormItem>
                        </Form>
                    </div>
                    <div class="register_bottom clear">
                        <div class="register_bottom_l"><span>已有账号，去<router-link :to="{name: 'Login'}">登录</router-link></span></div>
                        <div class="register_bottom_r"><router-link :to="{name: 'Findpassword'}">找回密码</router-link></div>
                    </div>
                </div>
                <div class="login_copyright_content"><span>{{tcpip}}</span></div>
            </div>
        </div>
        <!-- 漂浮客服 -->
        <ServerFixed></ServerFixed>
    </div>
</template>

<script>
import axios from 'axios'
import api from '@/request/api.js'
import qs from 'Qs'
import ServerFixed from '@/components/component/serverfixed.vue'
import identify from '@/components/component/identify.vue'
import { setInterval, clearTimeout, clearInterval } from 'timers';

export default {
    components: {ServerFixed, identify},
    data () {
        const phoneValidator = (rule, value, callback) => { // 手机号验证
            if (value === '' || value.length != 11 || isNaN(value)) {
                return callback(new Error(""));
            } else {
                callback();
            }
        }
        const identifierValidator = (rule, value, callback) => { // 识别码验证
            if (value === '' || value != this.identifyCode || value.length != 4 || isNaN(value)) {
                return callback(new Error(""));
                this.isIdentifier = false
            } else {
                this.isIdentifier = true
                callback();
            }
        }
        return {
            logoimg: '', // logo
            bgimg: '', // 背景图
            tcpip: '', // 备案信息
            registerValidate: { // 表单内容
                phone: '', // 手机号
                identifier: '', // 识别码
                verificationcode: '', // 验证码
                invitationcode: '', // 邀请码
            },
            registerRule: { // 表单验证
                phone: [ // 手机号
                    {validator: phoneValidator, trigger: 'blur'}
                ],
                identifier: [ // 识别码
                    {validator: identifierValidator, trigger: 'blur'}
                ],
                verificationcode: [ // 验证码
                    { required: true, message: '', trigger: 'blur' }
                ],
            },
            identifyCodes: "1234567890", // 验证码生成范围
            identifyCode: "", // 生成后的验证码
            identifiertxt: '获取验证码', // 验证码按钮文字
            isIdentifier: false, // 验证码按钮是否可点击
            verificationCodedisabled: false, // 验证码按钮点击之后禁止点击
        }
    },
    mounted () {
        this.refreshCode()
    },
    methods: {
        getInfo () { // 获取数据
            axios({
                url: this.getWebsite() + api.logininfo + this.getCookie('cook_ShopId'),
                method: 'post'
            })
            .then(response => {
                if (response.status === 200) {
                    // console.log(response.data.msg)
                    this.logoimg = response.data.msg.baseinfo.orderinglogo
                    this.bgimg = response.data.msg.backgroundlist[0]
                    this.tcpip = response.data.msg.tcpip
                    if (response.data.msg.baseinfo.is_selfreg == 0) {
                        this.$Message.error('不允许自主注册，请联系客服人员')
                        this.$router.push('/Login')
                    }
                }
            })
            .catch(error => {
                console.log(error)
            })
        },
        getCode () { // 获取验证码
            let data = {
                phone: this.registerValidate.phone
            }
            axios({
                url: this.getWebsite() + api.identifyingcode + this.getCookie('cook_ShopId'),
                method: 'post',
                data: qs.stringify(data)
            })
            .then(response => {
                if (response.status === 200) {
                    console.log(response.data.msg)
                    if (response.data.error) { // 获取验证码失效
                        this.$Message.error(response.data.msg)
                    } else {
                        let clearInter
                        let timesign = 60
                        
                        clearInter = setInterval(() => {
                            this.verificationCodedisabled = true
                            timesign--
                            this.identifiertxt = timesign + 's'
                            if (timesign <= 0) {
                                clearInterval(clearInter)
                                this.timesign = 60
                                this.identifiertxt = '重新获取验证码'
                                this.verificationCodedisabled = false
                            }
                        }, 1000)
                    }
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        submitInfo () { // 提交数据
            let data = {
                i_account: this.registerValidate.phone,
                i_phonecode: this.registerValidate.verificationcode
            }
            axios({
                url: this.getWebsite() + api.register + this.getCookie('cook_ShopId'),
                method: 'post',
                data: qs.stringify(data)
            })
            .then(response => {
                if (response.status === 200) {
                    console.log(response.data)
                    if (!response.data.error) { // 注册验证成功
                        // 验证成功提示
                        this.$Message.success(response.data.msg)
                        // 登录成功后跳转到指定页面
                        this.$router.push({
                            name: 'Evpi',
                            params: {
                                'phone': this.registerValidate.phone,
                                'invitationcode': this.registerValidate.invitationcode
                            }
                        })
                    } else { // 注册验证失败
                        this.$Message.error(response.data.msg)
                    }
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        randomNum (min, max) { // 生成随机数
            return Math.floor(Math.random() * (max - min) + min);
        },
        refreshCode () { // 更新验证码
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[this.randomNum(0, this.identifyCodes.length)]
            }
            // console.log(this.identifyCode)
        },
        getVerificationCode () { // 获取验证码
            if (this.isIdentifier && this.registerValidate.phone != '') {
                this.getCode()
            } else {
                if (this.registerValidate.phone == '') {
                    this.$Message.warning({
                        content: '请输入手机号'
                    })
                } else {
                    this.$Message.warning({
                        content: '请输入正确的识别码'
                    })
                }
            }
        },
        handleSubmit (name) { // 点击登录按钮
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.submitInfo()
                } else {
                    this.$Message.error('请填写完整信息!');
                }
            })
        },
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

.login_box {
    height: 580px;
    margin: -290px 0 0 -450px;
}

</style>


// WEBPACK FOOTER //
// src/components/views/login/register.vue